<!--
 * @Description:
 * @Date: 2019-03-29 13:49:26
 -->
<template>
  <div class="content-wrap">
    <template class>
      <headers style="width:100%;"></headers>
      <el-container style="background:#F7FBFF;">
        <nav-sides
          v-if="!asideInMain"
          class="aside-left"
          :is-collapse="isCollapse"
          v-show="ifShow"
        ></nav-sides>
        <el-container>
          <el-header class="custom-header">
            <!-- <div class="header-box">
                            <el-button type="primary" :icon="iconCollapse" class="collapse" size="mini" @click.native="changeCollapse" v-show='ifShow'></el-button>
                        </div>
            <breadcrumb></breadcrumb>-->
            <home-menu v-if="!projectId || !ifShow"></home-menu>
            <detail-breadcrumb v-else></detail-breadcrumb>
          </el-header>
          <el-main :style="mainStyle">
            <nav-sides
              v-if="asideInMain"
              class="aside-left"
              :is-collapse="isCollapse"
              v-show="ifShow"
            ></nav-sides>
            <router-view></router-view>
            <!-- qiankun: 子应用容器 -->
            <div id="subapp-container"></div>
          </el-main>
        </el-container>
      </el-container>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import NavSides from '@/components/Aside/index.vue';
import Mains from '@/components/Main/index.vue';
import Headers from '@/components/Header/index.vue';
import Breadcrumb from '@/components/Common/breadcrumb.vue';
import DetailBreadcrumb from './DetailBreadcrumb';
import HomeMenu from './components/HomeMenu';
export default {
  name: 'App',
  data() {
    return {
      isCollapse: false,
      iconCollapse: 'el-icon-arrow-left',
      ifShow: true,
      mainStyle: {},
      asideInMain: false
    };
  },
  components: {
    NavSides,
    Mains,
    Headers,
    Breadcrumb,
    DetailBreadcrumb,
    HomeMenu
  },
  methods: {
    ...mapMutations(['ISCOLLAPSE']),
    changeCollapse() {
      this.isCollapse = !this.isCollapse;

      this.isCollapse
        ? (this.iconCollapse = 'el-icon-arrow-right')
        : (this.iconCollapse = 'el-icon-arrow-left');
    }
  },
  computed: {
    ...mapState({
      projectId(state) {
        if (
          [
            '/accountManagement/subAccountManagement',
            '/zone/list',
            '/v3/digtal-storage/digtal-storage-list'
          ].includes(this.$route.path)
        ) {
          return '';
        }
        if (state.homeProject.id) {
          return state.homeProject.id;
        } else {
          // 暂时解决v3项目刷新页面，store中的homeProject未初始化问题
          let pId = '';
          try {
            pId = JSON.parse(localStorage.getItem('homeProject')).id;
          } catch (error) {}
          return pId;
        }
      }
    })
  },
  created() {
    if (document.body.clientWidth < 1175) {
      this.changeCollapse();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        const settlementPaths = [
          '/v3/settlement/index',
          '/v3/settlement/order-review',
          '/v3/settlement/payment-terminal'
        ];
        const zsPaths = [
          '/v3/zs-manage/config',
          '/v3/zs-manage/drug',
          '/v3/zs-manage/device',
          '/v3/zs-manage/ability',
          '/v3/zs-manage/person'
        ];
        this.ifShow = ![
          '/home',
          '/v3/home/index',
          '/contract/list',
          '/pCenter/index',
          '/download/list',
          '/dutypaidProof/list',
          '/invoice/list',
          '/v3/questionnaire/list',
          '/v3/persontask-progress/list',
          '/v3/persontask-progress/detail',
          '/v3/home/project-list-enterdetail',
          ...settlementPaths,
          ...zsPaths
        ].includes(this.$route.path);

        // 判断是否需要aside在main中
        this.asideInMain = v.meta.asideInMain;
        if (settlementPaths.includes(this.$route.path)) {
          this.mainStyle = { padding: 0 };
        } else if (this.asideInMain) {
          this.mainStyle = {
            display: 'flex',
            'justify-content': 'space-evenly'
          };
        } else {
          this.mainStyle = {};
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-header,
.el-footer {
  background: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 40px;
}

.el-aside {
  background-color: rgba(255, 255, 255, 1);
  color: #333;
  text-align: center;
  /* line-height: 200px; */
}

.el-aside * {
  font-size: 16px;
}

.el-main {
  background-color: rgba(247, 251, 255, 1);
  color: #333;
  text-align: center;
  /* line-height: 160px; */
  height: 100%;
  padding-bottom: 0;
  padding: 20px;
  /* padding: 1.56vw; */
}

body > .el-container {
  margin-bottom: 40px;
}
</style>

<style lang="scss">
/* 全局style */
.content-wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.header-box {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.collapse {
  transform: translateX(-100%);
  // margin-right: 20px;
}
</style>

<style lang="scss" scoped>
.custom-header {
  ::v-deep {
    & > div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
